import React from "react";

import ListItem from "@mui/material/ListItem";

type SidebarObjectListItemWrapperProps = {
    children: any;
};

const SidebarObjectListItemWrapper = ({
    children,
}: SidebarObjectListItemWrapperProps) => {
    return (    
        <ListItem>
            {children}
        </ListItem>
    );
}

export {
    SidebarObjectListItemWrapper
} 
